/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedSubjektListResponse } from '../types/PaginatedSubjektList';
import type { Registry } from '../types/Registry';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type SubjektyListRequest = {} | null | undefined;
export type SubjektyListResponse = PaginatedSubjektListResponse;

export type SubjektyListQuery = {
  /**
   * ```yaml
   * in: query
   * name: aktivni
   * schema:
   *   type: boolean
   * ```
   */
  aktivni?: boolean;

  /**
   * ```yaml
   * in: query
   * name: ico__icontains
   * schema:
   *   type: string
   * ```
   */
  ico__icontains?: string;

  /**
   * ```yaml
   * in: query
   * name: id_subjektu__icontains
   * schema:
   *   type: string
   * ```
   */
  id_subjektu__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;

  /**
   * ```yaml
   * in: query
   * name: poznamka__icontains
   * schema:
   *   type: string
   * ```
   */
  poznamka__icontains?: string;

  /**
   * ```yaml
   * in: query
   * name: registry
   * schema:
   *   type: array
   *   items:
   *     type: array
   *     items:
   *       enum:
   *         - SUBJEKT_EVIDENCE_DTI
   *         - EDITOR_ZPS
   *         - IS_DTMK
   *         - AZI
   *         - OPRAVNENY_ZADATEL
   *         - BUDOUCI_STAVEBNIK
   *       type: string
   *       description: |-
   *         * `SUBJEKT_EVIDENCE_DTI` - Subjekt evidence DTI
   *         * `EDITOR_ZPS` - Editor ZPS
   *         * `IS_DTMK` - IS DTMK
   *         * `AZI` - AZI
   *         * `OPRAVNENY_ZADATEL` - Oprávněný žadatel
   *         * `BUDOUCI_STAVEBNIK` - Budoucí stavebník
   *     nullable: true
   *     enum:
   *       - AZI
   *       - BUDOUCI_STAVEBNIK
   *       - EDITOR_ZPS
   *       - IS_DTMK
   *       - OPRAVNENY_ZADATEL
   *       - SUBJEKT_EVIDENCE_DTI
   * description: |-
   *   * `SUBJEKT_EVIDENCE_DTI` - Subjekt evidence DTI
   *   * `EDITOR_ZPS` - Editor ZPS
   *   * `IS_DTMK` - IS DTMK
   *   * `AZI` - AZI
   *   * `OPRAVNENY_ZADATEL` - Oprávněný žadatel
   *   * `BUDOUCI_STAVEBNIK` - Budoucí stavebník
   * explode: true
   * style: form
   * ```
   */
  registry?: Registry[];

  /**
   * ```yaml
   * name: search
   * required: false
   * in: query
   * description: A search term.
   * schema:
   *   type: string
   * ```
   */
  search?: string;

  /**
   * ```yaml
   * in: query
   * name: typ_osoby
   * schema:
   *   type: string
   *   nullable: true
   *   enum:
   *     - fyzickaOsoba
   *     - pravnickaOsoba
   * description: |-
   *   * `fyzickaOsoba` - Fyzická
   *   * `pravnickaOsoba` - Právnická
   * ```
   */
  typ_osoby?: ('fyzickaOsoba' | 'pravnickaOsoba') | null;
};

/**
 * GET /dmx-server/subjekty/
 *
 * ```yaml
 * operationId: subjekty_list
 * description: Seznam subjektů je synchronizován každý den v cca 01:00
 * tags:
 *   - subjekty
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedSubjektList'
 *     description: ''
 * ```
 */
export const subjektyListOperation = (rest?: SubjektyListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/subjekty/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/subjekty/' };
  };

/**
 * GET /dmx-server/subjekty/
 *
 * ```yaml
 * operationId: subjekty_list
 * description: Seznam subjektů je synchronizován každý den v cca 01:00
 * tags:
 *   - subjekty
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedSubjektList'
 *     description: ''
 * ```
 */
export const subjektyList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: SubjektyListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedSubjektListResponse>> => {
  const operation = subjektyListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/subjekty/
 */
export const useSubjektyListResource = (
  query: SubjektyListQuery | null,
  useCached?: boolean,
): UseResource<SubjektyListResponse> => {
  return useResource<SubjektyListResponse>({
    path: query === null ? null : subjektyListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
